import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=66a215ba&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66a215ba')) {
      api.createRecord('66a215ba', component.options)
    } else {
      api.reload('66a215ba', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=66a215ba&", function () {
      api.rerender('66a215ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27l2zJyDc321a/JS/pricehelp.vue"
export default component.exports